import Container from 'typedi';
import { ActionID, ISessionChannel, MessageBroker } from '@sparkware/uc-sdk-core';

import {
    IAuthenticationResult,
    IEnhancedLoginResult,
    IRegularAuthenticationService,
    IRegularLoginModel,
    IRegularLoginResponseModel,
    IAuthenticationService,
} from '../models';
import { loadAuthenticationService } from './authentication.service.loader';
import { AuthenticationFlowType } from '../enums';
import { RegularLoginDataBuilder } from './regular-logindata.builder.service';
import { LocalSimpleStoreService } from '../../storage/implementations/simple-store';
import { StorageItemEnum } from '../../../models/enums/storage-enums';

export class RegularAuthenticationService implements IRegularAuthenticationService {
    private _authenticationService?: IAuthenticationService;
    private readonly _regularLoginDataBuilder: RegularLoginDataBuilder;
    private readonly _localSimpleStoreService: LocalSimpleStoreService;

    private readonly _sessionChannel: ISessionChannel;

    constructor() {
        this._regularLoginDataBuilder = Container.get(RegularLoginDataBuilder);
        this._localSimpleStoreService = Container.get(LocalSimpleStoreService);
        this._sessionChannel = MessageBroker.getInstance().session;
    }

    public login = async (event): Promise<IAuthenticationResult<IRegularLoginResponseModel>> => {
        this._authenticationService = await loadAuthenticationService();
        return this._authenticationService.executeWithAnalytics(
            AuthenticationFlowType.Regular,
            async (): Promise<IAuthenticationResult<IRegularLoginResponseModel>> => {
                const loginModel: IRegularLoginModel = await this._createLoginData(event);

                const result: IAuthenticationResult<IRegularLoginResponseModel> =
                    await this._authenticationService.login(loginModel);

                const { response } = result;

                if (response?.Response?.BearerToken) {
                    await this.onSuccess(response);
                }

                return result;
            },
        );
    };

    protected onSuccess = async (response: IEnhancedLoginResult<IRegularLoginResponseModel>) => {
        this._authenticationService = await loadAuthenticationService();
        await this._authenticationService.continuePostLoginActions(response);
        if (this._localSimpleStoreService.get(StorageItemEnum.ActionStarted) === ActionID.login) {
            this._sessionChannel.topics.actionCompleted.publish(
                { publisher: 'AuthenticationService' },
                {},
            );
        }
    };

    private _createLoginData = async (data: any): Promise<IRegularLoginModel> => {
        const loginData = await this._regularLoginDataBuilder.Build(data);

        return loginData;
    };
}
